import React from 'react';
import {
  BlueBoxLogoIcon,
  DontLiveLifeWithoutLogoIcon,
} from '@americanexpress/consumer-travel-base';
import { Heading } from '@americanexpress/dls-react';
import styles from './Questions.scss';
import sharedStyles from '../../styles/shared.scss';
import Question from './Question';
import { useDataFromOneCMS } from '../../fetchye/useDataFromOneCMS';

const Questions = () => {
  const heading = useDataFromOneCMS('questionsSection.heading');
  const questions = useDataFromOneCMS('questionsSection.questions');

  return (
    <div className="dls-white-bg">
      <div className="container pad-2-tb pad-0-tb-sm-down" id="PWPFAQ">
        <div className="text-align-center pad-3-tb">
          <Heading level={2} variant="sans-large-book" className={sharedStyles.heading}>
            {' '}
            {heading}{' '}
          </Heading>
        </div>
        {questions.map((question) => (
          <Question key={question?.id} details={question} />
        ))}
      </div>
      <div
        aria-hidden="true"
        className="container pad-4-tb flex flex-align-center flex-justify-center"
      >
        <BlueBoxLogoIcon className={styles.blueBoxLogo} />
        <DontLiveLifeWithoutLogoIcon className={styles.dontLiveWithoutLogo} />
      </div>
    </div>
  );
};

export default Questions;
